/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Post_CreatedInputs */

const en_msg_post_created = /** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post published to your feed`)
};

const es_msg_post_created = /** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación añadida a tu feed`)
};

const fr_msg_post_created = /** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article publié dans votre flux`)
};

const de_msg_post_created = /** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag in deinem Feed veröffentlicht`)
};

const id_msg_post_created = /** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postingan diterbitkan ke feed Anda`)
};

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const ja_msg_post_created = en_msg_post_created;

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const zh_msg_post_created = en_msg_post_created;

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const ar_msg_post_created = en_msg_post_created;

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const it_msg_post_created = en_msg_post_created;

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const ru_msg_post_created = en_msg_post_created;

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const pt_msg_post_created = en_msg_post_created;

/** @type {(inputs: Msg_Post_CreatedInputs) => LocalizedString} */
const ko_msg_post_created = en_msg_post_created;

/**
* | output |
* | --- |
* | "Post published to your feed" |
*
* @param {Msg_Post_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_post_created = /** @type {((inputs?: Msg_Post_CreatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Post_CreatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_post_created(inputs)
	if (locale === "es") return es_msg_post_created(inputs)
	if (locale === "fr") return fr_msg_post_created(inputs)
	if (locale === "de") return de_msg_post_created(inputs)
	if (locale === "ja") return ja_msg_post_created(inputs)
	if (locale === "zh") return zh_msg_post_created(inputs)
	if (locale === "ar") return ar_msg_post_created(inputs)
	if (locale === "id") return id_msg_post_created(inputs)
	if (locale === "it") return it_msg_post_created(inputs)
	if (locale === "ru") return ru_msg_post_created(inputs)
	if (locale === "pt") return pt_msg_post_created(inputs)
	return ko_msg_post_created(inputs)
});